const POSTS_ROOT = '/posts'

const POSTS_ENDPOINT = {
  POSTS: POSTS_ROOT,
  ARTICLES: `${POSTS_ROOT}/articles`,
  MARK_AS_READ: `${POSTS_ROOT}/mark-as-read`,
  MARK_AS_VIEWED: `${POSTS_ROOT}/mark-as-viewed`,
  UPLOAD_IMAGE: `${POSTS_ROOT}/upload-image/:id`
}

export default POSTS_ENDPOINT
